module.exports = __webpack_public_path__ + "static/media/video-call_light.18548b35.svg";